import { useMemo, useState } from "react";
import styled from "styled-components";
import Overlay from "../../../Componentes/Overlay";
import FormComp from "../../../Componentes/FormComp";
import Modal from "../../../Componentes/Utils/Modal";
import { useModal } from "../../../contexts/ModalContext";

const Title = styled.h3`
    margin: 0 0 8px 0;
    font-size: 18px;
    color: #263b4b;
`;

const Subtitle = styled.p`
    margin: 0 0 20px 0;
    font-size: 14px;
    color: #555;
`;

const ModalSelecionarMes = ({ onConfirm, initialReferencia = "" }) => {
    const { closeModal } = useModal();
    const [referencia, setReferencia] = useState(initialReferencia);

    const mesAtual = useMemo(() => {
        const d = new Date();
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
    }, []);

    const confirmarPeriodo = (value) => {
        if (!value) return;

        if (value > mesAtual) {
            alert("Não é possível consultar um período futuro.");
            setReferencia("");
            return;
        }

        const [ano, mes] = value.split("-");

        if (!ano || !mes) {
            alert("Período inválido.");
            return;
        }

        onConfirm({ ano, mes });
        closeModal();
    };

    const handleReferenciaChange = (e) => {
        const value = e.target.value;
        setReferencia(value);
        confirmarPeriodo(value);
    };

    return (
        <Overlay state changeState={closeModal}>
            <Modal header close={closeModal} size="sm">
                <Title>Selecionar período</Title>
                <Subtitle>Escolha o mês e o ano para consultar a movimentação contábil.</Subtitle>
                <FormComp
                    title="MÊS / ANO"
                    type="month"
                    valor={referencia}
                    name="referencia"
                    changeFunc={handleReferenciaChange}
                    required
                />
            </Modal>
        </Overlay>
    );
};

export default ModalSelecionarMes;
